import { ExternalInfos } from '@/domain/external/entities/external.entity';
import { Scope } from '@/domain/external-invitation/entities/external-invitation.entity';

export enum ProjectCalculateMode {
  VENUE_SEASON = 'VENUE_SEASON',
  VENUE_DATE = 'VENUE_DATE',
  FESTIVAL = 'FESTIVAL',
  TOUR = 'TOUR',
  NONE = '',
}

type ModeByScope = {
  [key in Scope]: ProjectCalculateMode;
};

const MODES: ModeByScope = {
  '': ProjectCalculateMode.NONE,
  // FESTIVAL
  TEAM: ProjectCalculateMode.FESTIVAL,
  ARTISTS: ProjectCalculateMode.FESTIVAL,
  PUBLIC: ProjectCalculateMode.FESTIVAL,
  PUBLIC_SUPPLIER: ProjectCalculateMode.FESTIVAL,
  SITE: ProjectCalculateMode.FESTIVAL,
  // FESTIVAL CATEGORIES
  'TEAM-MOBILITY': ProjectCalculateMode.FESTIVAL,
  'TEAM-CATERING': ProjectCalculateMode.FESTIVAL,
  'TEAM-ACCOMMODATION': ProjectCalculateMode.FESTIVAL,
  'ARTISTS-MOBILITY': ProjectCalculateMode.FESTIVAL,
  'ARTISTS-CATERING': ProjectCalculateMode.FESTIVAL,
  'ARTISTS-ACCOMMODATION': ProjectCalculateMode.FESTIVAL,
  'ARTISTS-CARGO': ProjectCalculateMode.FESTIVAL,
  'SITE-ENERGY-WATER-WASTE': ProjectCalculateMode.FESTIVAL,
  'SITE-EQUIPMENT-CARGO': ProjectCalculateMode.FESTIVAL,
  'SITE-BUILDING': ProjectCalculateMode.FESTIVAL,
  // VENUE-STRUCTURE
  'VENUE-STRUCTURE-SITE': ProjectCalculateMode.VENUE_SEASON,
  'VENUE-STRUCTURE-TEAM': ProjectCalculateMode.VENUE_SEASON,
  // VENUE-STRUCTURE CATEGORIES
  'VENUE-STRUCTURE-TEAM-TRANSPORT': ProjectCalculateMode.VENUE_SEASON,
  'VENUE-STRUCTURE-TEAM-CATERING': ProjectCalculateMode.VENUE_SEASON,
  'VENUE-STRUCTURE-SITE-SCENOGRAPHY': ProjectCalculateMode.VENUE_SEASON,
  'VENUE-STRUCTURE-SITE-MATERIAL': ProjectCalculateMode.VENUE_SEASON,
  'VENUE-STRUCTURE-SITE-BUILDING': ProjectCalculateMode.VENUE_SEASON,
  'VENUE-STRUCTURE-SITE-ENERGY': ProjectCalculateMode.VENUE_SEASON,
  'VENUE-STRUCTURE-SITE-WATER': ProjectCalculateMode.VENUE_SEASON,
  'VENUE-STRUCTURE-SITE-WASTE': ProjectCalculateMode.VENUE_SEASON,
  'VENUE-STRUCTURE-SITE-EQUIPMENT': ProjectCalculateMode.VENUE_SEASON,
  'VENUE-STRUCTURE-PUBLIC': ProjectCalculateMode.VENUE_SEASON,
  'VENUE-STRUCTURE-PUBLIC-CATERING': ProjectCalculateMode.VENUE_SEASON,
  'VENUE-STRUCTURE-PUBLIC-DIGITAL': ProjectCalculateMode.VENUE_SEASON,
  // VENUE-DATES
  'VENUE-DATES-ARTISTS': ProjectCalculateMode.VENUE_DATE,
  // VENUE-DATES CATEGORIES
  'VENUE-DATES-ARTISTS-MOBILITY': ProjectCalculateMode.VENUE_DATE,
  'VENUE-DATES-ARTISTS-CATERING': ProjectCalculateMode.VENUE_DATE,
  'VENUE-DATES-ARTISTS-ACCOMMODATION': ProjectCalculateMode.VENUE_DATE,
  'VENUE-DATES-ARTISTS-CARGO': ProjectCalculateMode.VENUE_DATE,
  // SURVEY
  'SURVEY-MOBILITY-ACCOMMODATION': ProjectCalculateMode.FESTIVAL, // we use FESTIVAL calculation mode for surveys even when survey is linked to venue and tour project
};

export function getCalculateModeForScope(
  externalInfos: ExternalInfos,
): ProjectCalculateMode | undefined {
  const mode = MODES[externalInfos.scope];
  return mode;
}
